import { Network } from '@yme/services/network';
import { getData } from './getData';
const IMAGE_INFO_ENDPOINT = '/services/api/image-info';
const getPaths = (data) => {
    const expAssets = data.expAssets;
    const partnerLogo = data.partnerLogo;
    const primaryImage = data.primaryImage;
    return [
        ...expAssets.map((asset) => asset._path),
        partnerLogo?._path ?? '',
        primaryImage?._path ?? '',
    ];
};
export const getExperienceDetailsData = async (endpoint) => {
    return await getData(endpoint).then(async (response) => {
        const data = response.data.destinationByPath.item;
        const paths = getPaths(data);
        const imageResponse = await Network.post(IMAGE_INFO_ENDPOINT, paths);
        return {
            data,
            imageData: imageResponse.data,
        };
    });
};
